var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52447 0.463524C9.67415 0.00286901 10.3259 0.00287003 10.4755 0.463525L12.3574 6.25532C12.4243 6.46133 12.6163 6.60081 12.8329 6.60081H18.9228C19.4071 6.60081 19.6085 7.22062 19.2167 7.50532L14.2899 11.0848C14.1146 11.2122 14.0413 11.4379 14.1082 11.6439L15.9901 17.4357C16.1398 17.8963 15.6125 18.2794 15.2207 17.9947L10.2939 14.4152C10.1186 14.2878 9.88135 14.2878 9.70611 14.4152L4.77931 17.9947C4.38745 18.2794 3.86021 17.8963 4.00989 17.4357L5.89176 11.6439C5.9587 11.4379 5.88537 11.2122 5.71012 11.0848L0.783326 7.50532C0.39147 7.22062 0.592859 6.60081 1.07722 6.60081H7.16708C7.38369 6.60081 7.57567 6.46133 7.6426 6.25532L9.52447 0.463524Z",
    fill: "#00C141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/Star1.b09afb12af143d7432e46a6f421b4249.svg";
export { ForwardRef as ReactComponent };